<notify-popup
  *ngIf="showConfirmPopup"
  [title]="confirmTitle | translate"
  [msg]="confirmMsg | translate"
  [okLabel]="confirmOkLabel | translate"
  [cancelLabel]="'Common.Cancel' | translate"
  (onChanged)="onConfirmResult($event)"
>
</notify-popup>

<div
  class="match-priority-backdrop"
  [class.is-blocked]="showConfirmPopup"
  (click)="onBackdropClick()"
></div>

<div
  class="match-priority-shell"
  [class.place-above]="placeAbove && !isSheet"
  [class.is-ready]="isPositioned"
  [class.is-sheet]="isSheet"
  [style.top.px]="isSheet ? null : shellTop"
  [style.left.px]="isSheet ? null : shellLeft"
  [style.--arrow-inset.px]="arrowInset"
  [style.--mp-body-max]="bodyMaxHeight != null ? bodyMaxHeight + 'px' : 'none'"
  (click)="$event.stopPropagation()"
>
  <span class="match-priority-arrow" aria-hidden="true"></span>

  <div class="match-priority-card">
    <div class="match-priority-card__header">
      <div class="match-priority-card__header-left">
        <div class="match-priority-card__title">
          {{ 'MatchPriority.Title' | translate }}
        </div>
        <span
          class="match-priority-card__badge"
          [ngClass]="sourceBadgeClass"
          *ngIf="!isLoading"
        >
          {{ sourceBadgeLabel | translate }}
        </span>
        <span class="match-priority-card__badge is-skeleton" *ngIf="isLoading"></span>
      </div>
      <button
        type="button"
        class="match-priority-card__close"
        (click)="onClose($event)"
        [attr.aria-label]="'Common.Close' | translate"
      >
        <i class="app-ico-mask app-ico-mask__x"></i>
      </button>
    </div>

    <div class="match-priority-card__body" *ngIf="isLoading">
      <div class="match-priority-skeleton-item" *ngFor="let item of criteriaList">
        <div class="match-priority-skeleton-line is-label"></div>
        <div class="match-priority-skeleton-control">
          <div class="match-priority-skeleton-line is-track"></div>
          <div class="match-priority-skeleton-line is-val"></div>
        </div>
      </div>
    </div>

    <div class="match-priority-card__body" *ngIf="!isLoading">
      <div class="match-priority-item" *ngFor="let item of criteriaList">
        <label class="match-priority-item__label" [attr.for]="'mp-slider-' + item.key">
          {{ item.labelKey | translate }}
        </label>
        <div class="match-priority-item__control">
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            class="match-priority-slider"
            [id]="'mp-slider-' + item.key"
            [value]="weights[item.key] || 0"
            [style.--slider-percent.%]="weights[item.key] || 0"
            (input)="onWeightChange(item.key, $event)"
          />
          <span class="match-priority-item__value">{{ weights[item.key] || 0 }}</span>
        </div>
      </div>
    </div>

    <div class="match-priority-card__footer" *ngIf="!isLoading">
      <div
        class="match-priority-card__total"
        [class.is-invalid]="isWeightTotalInvalid"
      >
        {{ 'MatchPriority.WeightTotal' | translate:{ total: totalWeight } }}
      </div>
      <div
        class="match-priority-card__error"
        *ngIf="errorMessage"
        [attr.title]="errorMessage | translate"
      >
        {{ errorMessage | translate }}
      </div>
    </div>

    <div class="match-priority-card__actions" *ngIf="isLoading">
      <div class="match-priority-skeleton-line is-action-btn"></div>
    </div>

    <div class="match-priority-card__actions" *ngIf="!isLoading">
      <button
        type="button"
        class="match-priority-action-btn"
        (click)="requestSaveConfirmation()"
        [disabled]="isSaving || !canSave"
        [class.is-disabled]="isSaving || !canSave"
      >
        <span class="main-loader" *ngIf="isSaving && pendingAction === 'save'"></span>
        <span>{{ saveLabelKey | translate }}</span>
      </button>

      <button
        type="button"
        class="match-priority-reset-btn"
        *ngIf="canReset"
        (click)="requestResetConfirmation()"
        [disabled]="isSaving"
        [class.is-disabled]="isSaving"
      >
        <span class="main-loader" *ngIf="isSaving && pendingAction === 'reset'"></span>
        <span>{{ resetLabelKey | translate }}</span>
      </button>
    </div>
  </div>
</div>
